import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Modal from "../../components/modal/modal"; // путь к твоей модалке

const AddNews = () => {
  const { id } = useParams(); // user_id
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalMessage, setModalMessage] = useState(null); // ✅ для модалки

  useEffect(() => {
    if (!imageFile) return;
    const objectUrl = URL.createObjectURL(imageFile);
    setImagePreview(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [imageFile]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Проверка полей
    if (!title || !description || !imageFile) {
      setModalMessage({
        title: t("error"),
        text: t("allfields"),
        success: false,
        ok: t("ok"),
      });
      return;
    }

    const formData = new FormData();
    formData.append("user_id", id);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", imageFile);

    try {
      setLoading(true);
      const res = await fetch("/api/add_company_news.php", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.success) {
        setModalMessage({
          title: t("success"),
          text: t("news_added_success"),
          success: true,
          ok: t("ok"),
          onClose: () => navigate(`/MyNews/${id}`),
        });
      } else {
        setModalMessage({
          title: t("error"),
          text: t("error_adding_news"),
          success: false,
          ok: t("ok"),
        });
      }
    } catch (err) {
      console.error("Error:", err);
      setModalMessage({
        title: t("error"),
        text: t("server_error"),
        success: false,
        ok: t("ok"),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="w-full opacity-0 animate-[showtitle_1s_forwards] flex justify-center p-3 items-center flex-col">
      {/* Модалка */}
      {modalMessage && (
        <Modal
          title={modalMessage.title}
          text={modalMessage.text}
          success={modalMessage.success}
          ok={modalMessage.ok}
          onClose={() => {
            if (modalMessage.onClose) modalMessage.onClose();
            setModalMessage(null);
          }}
        />
      )}

      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-2xl my-12 rounded-2xl w-[700px] max-md:w-full overflow-hidden flex flex-col"
      >
        <h1 className="bg-[#006674] p-3 text-center text-white text-3xl max-sm:text-xl font-semibold">
          {t("postnews")}
        </h1>
        <div className="flex w-full flex-col justify-start items-center gap-3 ">
          {/* Фото с превью */}
          <label className="flex flex-col items-center justify-center h-[300px] max-sm:h-[200px] w-full bg-gray-400 cursor-pointer overflow-hidden">
            {imagePreview ? (
              <img
                src={imagePreview}
                alt="preview"
                className="h-full w-full object-cover"
              />
            ) : (
              <>
                <span className="font-semibold uppercase">{t("photo")}</span>
                <span className="font-semibold uppercase">
                  {t("onlyonephoto")}
                </span>
              </>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setImageFile(e.target.files[0])}
              className="hidden"
            />
          </label>

          <div className="p-6 w-full">
            <label className="flex w-full flex-col gap-1">
              <span className="font-semibold uppercase text-[#006674]">
                {t("title")}
              </span>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="border rounded-lg w-full transition-all p-2 outline-none focus:ring-2 ring-[#006674]"
              />
            </label>

            <label className="flex flex-col w-full gap-1">
              <span className="font-semibold uppercase text-[#006674]">
                {t("information")}
              </span>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="border w-full rounded-lg p-2 min-h-[120px] transition-all outline-none focus:ring-2 ring-[#006674]"
              ></textarea>
            </label>

            <button
              type="submit"
              disabled={loading}
              className="bg-[#006674] w-full text-white py-2 px-4 mt-3 rounded-lg hover:bg-[#008ca6] transition-all duration-200 disabled:opacity-60"
            >
              {loading ? t("Adding...") : t("post")}
            </button>
          </div>
        </div>
      </form>
    </section>
  );
};

export default AddNews;
